import axios from 'axios';

const BASE_API = "https://api.v2202405.nlclimitada.com";
export const api = axios.create({
    baseURL: BASE_API
});

api.defaults.headers.post['Content-Type'] = 'application/json';
